module.exports = __webpack_public_path__ + "4b4c30063e3cd246e9f69fb55f69d26e.mp4";